import { FC, useEffect } from 'react'
import cn from 'classnames'

import { Portal } from '@src/components/Portal/Portal'
// import { ReactComponent as Close } from '@src/assets/close.svg'
import style from './Modal.module.scss'

type ModalPropsType = {
  close?: () => void
  isOpen: boolean
  styleModalWindow?: string
  stylePositionModalWindow?: string
}

export const Modal: FC<ModalPropsType> = ({
  styleModalWindow, stylePositionModalWindow, children, close, isOpen,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  return (
    <>
      {isOpen && (
        <Portal>
          <div className={cn(style.modal, stylePositionModalWindow)}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div className={style.bg} onClick={close} />
            <div className={cn(style.content, styleModalWindow)}>
              <button type="button" onClick={close} className={style.successModalClose}>
                {/* <Close /> */}
                <div className={style.closeIcon} />
              </button>
              {children}
            </div>
          </div>
        </Portal>
      )}
    </>
  )
}
